import { createContext, useContext, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const CommerceContext = createContext({ commerceEnabled: null, stripeMode: "test" });

// Server-enforced COMMERCE_ENABLED flag. null = loading (treated as disabled, fail-closed).
export const CommerceProvider = ({ children }) => {
  const [config, setConfig] = useState({ commerceEnabled: null, stripeMode: "test" });
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/commerce/config`)
      .then((r) => (r.ok ? r.json() : { commerce_enabled: false }))
      .then((d) => alive && setConfig({ commerceEnabled: !!d.commerce_enabled, stripeMode: d.stripe_mode || "test" }))
      .catch(() => alive && setConfig({ commerceEnabled: false, stripeMode: "test" }));
    return () => { alive = false; };
  }, []);
  return <CommerceContext.Provider value={config}>{children}</CommerceContext.Provider>;
};

export const useCommerce = () => useContext(CommerceContext);
